<template>
  <div class="landing-root">
    <!-- NAV -->
    <nav class="landing-nav">
      <div class="nav-inner">
        <div class="nav-logo">
          <img src="/logo.ico" alt="CucuruchoOnline" class="nav-logo-img" />
          <span class="nav-brand">CucuruchoOnline</span>
        </div>
        <div class="nav-links">
          <router-link to="/privacidad" class="nav-link">Política de Privacidad</router-link>
          <router-link to="/sistema" class="nav-cta">Ir al Sistema →</router-link>
        </div>
      </div>
    </nav>

    <!-- HERO -->
    <section class="hero">
      <div class="hero-overlay"></div>
      <div class="hero-content">
        <span class="hero-badge">🕯️ Semana Santa Guatemala</span>
        <h1 class="hero-title">La plataforma digital para la gestión de hermandades</h1>
        <p class="hero-subtitle">
          Administrá inscripciones, turnos, procesiones y seguí el recorrido en tiempo real,
          todo desde un solo lugar.
        </p>
        <div class="hero-actions">
          <router-link to="/sistema" class="btn-primary">Ir al Sistema →</router-link>
          <a href="#features" class="btn-secondary">Conocer más ↓</a>
        </div>
      </div>
      <div class="hero-image-wrap">
        <!-- Glow orb de fondo -->
        <div class="hero-glow"></div>
        <!-- Anillo decorativo -->
        <div class="hero-ring"></div>

        <!-- Imagen principal -->
        <div class="hero-image-frame">
          <img src="../assets/cucurucho-sf.png" alt="Cucurucho" class="hero-image" />
        </div>

        <!-- Tarjeta flotante superior izquierda -->
        <div class="float-card float-card--tl">
          <span class="float-card__icon">📍</span>
          <div>
            <div class="float-card__title">Tracking Live</div>
            <div class="float-card__sub">Ubicación en tiempo real</div>
          </div>
        </div>

        <!-- Tarjeta flotante inferior derecha -->
        <div class="float-card float-card--br">
          <span class="float-card__icon">🕐</span>
          <div>
            <div class="float-card__title">Turnos organizados</div>
            <div class="float-card__sub">Cargadores asignados</div>
          </div>
        </div>

        <!-- Pill flotante superior derecha -->
        <div class="float-pill">
          <span class="float-pill__dot"></span>
          Sistema activo
        </div>
      </div>
    </section>

    <!-- FEATURES -->
    <section id="features" class="features">
      <div class="features-inner">
        <h2 class="section-title">Todo lo que necesitás, en un solo sistema</h2>
        <p class="section-subtitle">Diseñado específicamente para las hermandades de Guatemala</p>
        <div class="features-grid">
          <div class="feature-card">
            <div class="feature-icon">📍</div>
            <h3>Tracking en Tiempo Real</h3>
            <p>Seguí el recorrido de la procesión en un mapa interactivo, con actualización automática de ubicación.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">⛪</div>
            <h3>Gestión de Procesiones</h3>
            <p>Administrá múltiples procesiones y hermandades con sus rutas, horarios y estado del recorrido.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">📋</div>
            <h3>Inscripciones</h3>
            <p>Gestioná las inscripciones de cargadores de forma digital, con generación automática de recibos.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">🕐</div>
            <h3>Asignación de Turnos</h3>
            <p>Organizá y asigná los turnos de cargadores de manera eficiente para cada procesión.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">📊</div>
            <h3>Dashboard</h3>
            <p>Accedé a estadísticas e información centralizada de tu hermandad desde un panel de control.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">🔒</div>
            <h3>Acceso Seguro</h3>
            <p>Sistema de autenticación segura con roles y permisos personalizados por hermandad.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA FINAL -->
    <section class="cta-section">
      <div class="cta-inner">
        <div class="cta-image-frame">
          <img src="../assets/cucurucho-sf.png" alt="Cucurucho" class="cta-image" />
        </div>
        <div class="cta-content">
          <h2>¿Listo para digitalizar tu hermandad?</h2>
          <p>Accedé al sistema con tus credenciales y comenzá a gestionar tu procesión.</p>
          <router-link to="/sistema" class="btn-primary">Iniciar Sesión →</router-link>
        </div>
      </div>
    </section>

    <!-- CONTACT -->
    <ContactForm />

    <!-- FOOTER -->
    <footer class="landing-footer">
      <div class="footer-inner">
        <span class="footer-brand">© 2026 CucuruchoOnline</span>
        <div class="footer-links">
          <router-link to="/" class="footer-link">Inicio</router-link>
          <router-link to="/privacidad" class="footer-link">Política de Privacidad</router-link>
          <router-link to="/sistema" class="footer-link">Ir al Sistema</router-link>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import ContactForm from '@/components/ContactForm.vue';

export default {
  name: 'LandingView',
  components: {
    ContactForm
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

* { box-sizing: border-box; margin: 0; padding: 0; }

.landing-root {
  font-family: 'Inter', sans-serif;
  color: #1a1a2e;
  background: #fff;
  min-height: 100vh;
  overflow-x: hidden;
}

/* ── NAV ── */
.landing-nav {
  position: fixed;
  top: 0; left: 0; right: 0;
  z-index: 100;
  background: rgba(10, 10, 18, 0.92);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255,255,255,0.08);
}
.nav-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 14px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.nav-logo { display: flex; align-items: center; gap: 12px; }
.nav-logo-img { height: 36px; width: auto; border-radius: 6px; }
.nav-brand { color: #fff; font-weight: 700; font-size: 1.1rem; letter-spacing: 0.02em; }
.nav-links { display: flex; align-items: center; gap: 24px; }
.nav-link { color: rgba(255,255,255,0.7); text-decoration: none; font-size: 0.9rem; transition: color 0.2s; }
.nav-link:hover { color: #fff; }
.nav-cta {
  background: linear-gradient(135deg, #7b2ff7, #4a1b9a);
  color: #fff;
  text-decoration: none;
  padding: 9px 20px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.2s;
  box-shadow: 0 4px 14px rgba(123, 47, 247, 0.35);
}
.nav-cta:hover { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(123,47,247,0.5); }

/* ── HERO ── */
.hero {
  min-height: 100vh;
  background: linear-gradient(160deg, #0a0a12 0%, #1a0a30 50%, #0d1117 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 120px 8vw 80px;
  position: relative;
  overflow: hidden;
  gap: 80px;
}
.hero::before {
  content: '';
  position: absolute;
  top: -200px; right: -200px;
  width: 600px; height: 600px;
  background: radial-gradient(circle, rgba(123,47,247,0.18) 0%, transparent 70%);
  pointer-events: none;
}
.hero-overlay {
  position: absolute; inset: 0;
  background: url('../assets/cruz.jpg') center/cover no-repeat;
  opacity: 0.04;
  pointer-events: none;
}
.hero-content {
  flex: 1;
  max-width: 520px;
  position: relative;
  z-index: 1;
}
.hero-badge {
  display: inline-block;
  background: rgba(123,47,247,0.2);
  border: 1px solid rgba(123,47,247,0.4);
  color: #c4a0ff;
  padding: 6px 16px;
  border-radius: 100px;
  font-size: 0.82rem;
  font-weight: 500;
  margin-bottom: 24px;
  letter-spacing: 0.03em;
}
.hero-title {
  font-size: clamp(2rem, 4vw, 3.2rem);
  font-weight: 800;
  color: #fff;
  line-height: 1.15;
  margin-bottom: 20px;
}
.hero-subtitle {
  font-size: 1.1rem;
  color: rgba(255,255,255,0.6);
  line-height: 1.7;
  margin-bottom: 40px;
}
.hero-actions { display: flex; gap: 16px; flex-wrap: wrap; }
.btn-primary {
  background: linear-gradient(135deg, #7b2ff7, #4a1b9a);
  color: #fff;
  text-decoration: none;
  padding: 14px 28px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 1rem;
  transition: all 0.25s;
  box-shadow: 0 6px 20px rgba(123,47,247,0.4);
  display: inline-block;
}
.btn-primary:hover { transform: translateY(-2px); box-shadow: 0 10px 30px rgba(123,47,247,0.55); }
.btn-secondary {
  color: rgba(255,255,255,0.7);
  text-decoration: none;
  padding: 14px 28px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 1rem;
  border: 1px solid rgba(255,255,255,0.15);
  transition: all 0.25s;
  display: inline-block;
}
.btn-secondary:hover { background: rgba(255,255,255,0.06); color: #fff; }
.hero-image-wrap {
  flex: 0 0 auto;
  position: relative;
  z-index: 1;
  width: 500px;
  height: 580px;
}

/* Orbe de glow central */
.hero-glow {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 360px; height: 360px;
  background: radial-gradient(circle, rgba(123,47,247,0.22) 0%, transparent 70%);
  border-radius: 50%;
  pointer-events: none;
}

/* Anillo decorativo */
.hero-ring {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 420px; height: 420px;
  border-radius: 50%;
  border: 1px solid rgba(123,47,247,0.18);
  pointer-events: none;
  animation: ring-pulse 4s ease-in-out infinite;
}
@keyframes ring-pulse {
  0%, 100% { opacity: 0.4; transform: translate(-50%, -50%) scale(1); }
  50%       { opacity: 1;   transform: translate(-50%, -50%) scale(1.04); }
}

.hero-image-frame {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 340px;
  height: 500px;
  background: transparent;
}
.hero-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: transparent;
  display: block;
  filter: drop-shadow(0 20px 50px rgba(0,0,0,0.6));
  animation: float-img 6s ease-in-out infinite;
}
@keyframes float-img {
  0%, 100% { transform: translateY(0); }
  50%       { transform: translateY(-10px); }
}

/* Tarjetas flotantes */
.float-card {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(15, 10, 28, 0.82);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(123,47,247,0.3);
  border-radius: 14px;
  padding: 12px 16px;
  z-index: 3;
  animation: float-card 5s ease-in-out infinite;
  box-shadow: 0 8px 32px rgba(0,0,0,0.4);
}
@keyframes float-card {
  0%, 100% { transform: translateY(0); }
  50%       { transform: translateY(-6px); }
}
.float-card--tl {
  top: 48px; left: -8px;
  animation-delay: 0s;
}
.float-card--br {
  bottom: 48px; right: -8px;
  animation-delay: 2.5s;
}
.float-card__icon { font-size: 1.4rem; flex-shrink: 0; }
.float-card__title {
  font-size: 0.82rem;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
}
.float-card__sub {
  font-size: 0.72rem;
  color: rgba(255,255,255,0.5);
  white-space: nowrap;
}

/* Pill flotante */
.float-pill {
  position: absolute;
  top: 10px; right: -4px;
  display: flex;
  align-items: center;
  gap: 7px;
  background: rgba(15, 10, 28, 0.82);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(123,47,247,0.25);
  border-radius: 100px;
  padding: 7px 14px;
  font-size: 0.78rem;
  font-weight: 600;
  color: rgba(255,255,255,0.8);
  z-index: 3;
  animation: float-card 7s ease-in-out infinite;
  animation-delay: 1.2s;
  box-shadow: 0 4px 16px rgba(0,0,0,0.3);
}
.float-pill__dot {
  width: 7px; height: 7px;
  border-radius: 50%;
  background: #4ade80;
  box-shadow: 0 0 6px rgba(74,222,128,0.8);
  animation: blink 2s ease-in-out infinite;
}
@keyframes blink {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.4; }
}

/* ── FEATURES ── */
.features {
  background: #f8f9fd;
  padding: 100px 32px;
}
.features-inner { max-width: 1200px; margin: 0 auto; }
.section-title {
  text-align: center;
  font-size: clamp(1.6rem, 3vw, 2.4rem);
  font-weight: 800;
  color: #1a1a2e;
  margin-bottom: 12px;
}
.section-subtitle {
  text-align: center;
  color: #666;
  font-size: 1.05rem;
  margin-bottom: 60px;
}
.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 28px;
}
.feature-card {
  background: #fff;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 2px 20px rgba(0,0,0,0.06);
  border: 1px solid rgba(0,0,0,0.05);
  transition: all 0.3s;
}
.feature-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(123,47,247,0.12);
  border-color: rgba(123,47,247,0.15);
}
.feature-icon { font-size: 2.4rem; margin-bottom: 16px; }
.feature-card h3 { font-size: 1.1rem; font-weight: 700; color: #1a1a2e; margin-bottom: 10px; }
.feature-card p { color: #666; font-size: 0.95rem; line-height: 1.6; }

/* ── CTA ── */
.cta-section {
  background: linear-gradient(160deg, #0a0a12 0%, #1a0a30 100%);
  padding: 100px 32px;
}
.cta-inner {
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 60px;
}
.cta-image-frame {
  width: 240px;
  height: 300px;
  flex-shrink: 0;
  background: transparent;
}
.cta-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: transparent;
  display: block;
  filter: drop-shadow(0 16px 32px rgba(0,0,0,0.5));
}
.cta-content h2 {
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  font-weight: 800;
  color: #fff;
  margin-bottom: 16px;
}
.cta-content p {
  color: rgba(255,255,255,0.6);
  font-size: 1.05rem;
  margin-bottom: 32px;
  line-height: 1.6;
}

/* ── FOOTER ── */
.landing-footer {
  background: #07070f;
  padding: 24px 32px;
}
.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.footer-brand { color: rgba(255,255,255,0.4); font-size: 0.85rem; }
.footer-links { display: flex; gap: 24px; }
.footer-link { color: rgba(255,255,255,0.4); text-decoration: none; font-size: 0.85rem; transition: color 0.2s; }
.footer-link:hover { color: rgba(255,255,255,0.75); }

/* ── RESPONSIVE ── */
@media (max-width: 768px) {
  .hero { flex-direction: column; padding: 110px 20px 60px; gap: 40px; }
  .hero-image-wrap { width: 280px; height: 340px; }
  .hero-glow { width: 260px; height: 260px; }
  .hero-ring { width: 300px; height: 300px; }
  .hero-image-frame { width: 200px; height: 300px; }
  .float-card { display: none; }
  .float-pill { right: auto; left: 50%; transform: translateX(-50%); top: -4px; }
  .nav-inner { padding: 12px 20px; }
  .nav-brand { display: none; }
  .nav-link { display: none; }
  .cta-inner { flex-direction: column; text-align: center; }
  .cta-image { width: 180px; height: 220px; }
  .footer-inner { flex-direction: column; text-align: center; }
}
</style>
